"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnQueryRequest = exports.getNextPage = exports.extractPageData = void 0;
const react_1 = require("react");
const libs_utils_1 = require("@hotelplan/libs.utils");
const extractPageData = ({ pageNumber, resultsTotal, resultsPerPage, } = {}) => {
    return {
        pageNumber: pageNumber || 0,
        resultsTotal: resultsTotal || undefined,
        resultsPerPage: resultsPerPage || undefined,
    };
};
exports.extractPageData = extractPageData;
const getNextPage = (suggestions, page) => {
    const { pageNumber = 0, resultsTotal = 0, resultsPerPage = 0 } = page || {};
    return suggestions.length
        ? (0, libs_utils_1.calculateNextPage)(pageNumber, resultsPerPage, resultsTotal) || 0
        : 0;
};
exports.getNextPage = getNextPage;
const useOnQueryRequest = (onSuggestionsQuery, minQueryLength, showSuggestions, hideSuggestions) => {
    return (0, react_1.useCallback)((text, selectedItems, pageNumber) => {
        if (pageNumber || text.length >= minQueryLength) {
            onSuggestionsQuery(text, selectedItems, pageNumber);
            showSuggestions();
        }
        else {
            hideSuggestions();
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSuggestionsQuery, minQueryLength]);
};
exports.useOnQueryRequest = useOnQueryRequest;
//# sourceMappingURL=Autocomplete.utils.js.map